import _extends from "@babel/runtime/helpers/extends";
import React, { forwardRef, useEffect, useImperativeHandle, useRef, useState } from 'react';
import { cls } from '@arco-design/mobile-utils';
import { Collapse } from './collapse';
import { CollapseGroupContext } from './utils';
import { ContextLayout } from '../context-provider';
export function componentGenerator(Comp) {
  return /*#__PURE__*/forwardRef(function (props, ref) {
    var _props$items = props.items,
        items = _props$items === void 0 ? [] : _props$items,
        _props$className = props.className,
        className = _props$className === void 0 ? '' : _props$className,
        _props$style = props.style,
        style = _props$style === void 0 ? {} : _props$style,
        _props$defaultActiveI = props.defaultActiveItems,
        defaultActiveItems = _props$defaultActiveI === void 0 ? [] : _props$defaultActiveI,
        _props$useAccordion = props.useAccordion,
        useAccordion = _props$useAccordion === void 0 ? false : _props$useAccordion,
        _props$disabled = props.disabled,
        disabled = _props$disabled === void 0 ? false : _props$disabled,
        children = props.children;

    var _useState = useState([]),
        innerActiveItems = _useState[0],
        setInnerActiveItems = _useState[1];

    var _useState2 = useState([]),
        activeItems = _useState2[0],
        setActiveItems = _useState2[1];
    /** 用于children模式下的active管理 */


    var _useState3 = useState([]),
        childActiveItems = _useState3[0],
        setChildActiveItems = _useState3[1];

    var domRef = useRef(null);

    var formatArray = function formatArray(input) {
      var arr = input;
      return items.map(function (item) {
        return arr.indexOf(item.value) > -1;
      });
    };

    var handleChange = function handleChange(value) {
      if (disabled) return;

      if (props.onCollapse) {
        props.onCollapse(value);
      }

      if (props.activeItems !== void 0) {
        setInnerActiveItems(formatArray(props.activeItems));
        setChildActiveItems(props.activeItems);
        return;
      }

      if (!children) {
        var temp = items.findIndex(function (item) {
          return item.value === value;
        });
        if (temp < 0 || items[temp].disabled) return;
        var tempActiveItems = innerActiveItems.map(function (activeItem, index) {
          return index === temp ? !activeItem : !useAccordion && activeItem;
        });
        setInnerActiveItems(tempActiveItems);
      } else {
        var tempValue = childActiveItems.includes(value);
        setChildActiveItems(tempValue ? childActiveItems.filter(function (item) {
          return item !== value;
        }) : useAccordion // 手风琴模式只有一个展开项
        ? [value] : [].concat(childActiveItems, [value]));
      }
    };

    useEffect(function () {
      setInnerActiveItems(formatArray(defaultActiveItems));
      setChildActiveItems(defaultActiveItems);
    }, []);
    useEffect(function () {
      setActiveItems(props.activeItems === void 0 ? innerActiveItems : formatArray(props.activeItems));

      if (children && props.activeItems) {
        setChildActiveItems(props.activeItems);
      }
    }, [props.activeItems, innerActiveItems]);
    useImperativeHandle(ref, function () {
      return {
        dom: domRef.current
      };
    });
    return /*#__PURE__*/React.createElement(ContextLayout, null, function (_ref) {
      var prefixCls = _ref.prefixCls;
      return /*#__PURE__*/React.createElement("div", {
        className: cls(prefixCls + "-collapse-group", className),
        style: style,
        ref: domRef
      }, /*#__PURE__*/React.createElement(CollapseGroupContext.Provider, {
        value: {
          isGroup: true,
          onCollapse: handleChange,
          disabled: disabled,
          value: children ? childActiveItems : void 0
        }
      }, children || /*#__PURE__*/React.createElement(React.Fragment, null, items.map(function (item, index) {
        var compProps = _extends({
          active: activeItems[index],
          disabled: disabled || item.disabled,
          defaultActive: formatArray(defaultActiveItems)[index]
        }, item);

        return /*#__PURE__*/React.createElement(Comp, _extends({
          key: item.value
        }, compProps));
      }))));
    });
  });
}
export var Group = componentGenerator(Collapse);
export default Group;